import Vue from 'vue'
import Router from 'vue-router'

import LoginPage from './views/LoginPage'
import VisitsPage from './views/VisitsPage'
import PetsPage from './views/PetsPage'
import ProfilePage from './views/ProfilePage'
import RegisterPage from './views/RegisterPage.vue'
import ResetPasswordPage from './views/ResetPasswordPage.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      redirect: '/',
    },
    {
      path: '/',
      name: 'LoginPage',
      component: LoginPage,
    },
    {
      path: '/visits',
      name: 'VisitsPage',
      component: VisitsPage,
    },
    {
      path: '/pets',
      name: 'PetsPage',
      component: PetsPage,
    },
    {
      path: '/profile',
      name: 'ProfilePage',
      component: ProfilePage,
    },
    {
      path: '/register',
      name: 'RegisterPage',
      component: RegisterPage,
    },
    {
      path: '/resetPassword',
      name: 'ResetPasswordPage',
      component: ResetPasswordPage,
    },
  ],
})
